import { MutationOriginIntegrationUpdateArgs, VcsCheck } from "types/generated";

import { ManageOriginManualFormFields } from "./types";
import { UpdateOriginIntegrationData } from "./gql";

export const getFormDefaultValues = (
  integration?: UpdateOriginIntegrationData
): ManageOriginManualFormFields => {
  const useGitCheckoutValue = integration ? integration?.useGitCheckout : true;

  return {
    vcsChecks: integration?.vcsChecks || VcsCheck.Individual,
    useGitCheckout: useGitCheckoutValue,
    individualFailuresOnly: integration?.vcsCheckOptions?.individualFailuresOnly ?? false,
    individualSkipUnchanged: integration?.vcsCheckOptions?.individualSkipUnchanged ?? false,
  };
};

export const mapUpdateOriginIntegrationInputValues = (
  values: ManageOriginManualFormFields
): MutationOriginIntegrationUpdateArgs => ({
  vcsChecks: values.vcsChecks,
  vcsCheckOptions: {
    individualFailuresOnly: values.individualFailuresOnly,
    individualSkipUnchanged: values.individualSkipUnchanged,
  },
});
